import Model from "../../../../Model.js";

/**
 * Represent where data for a period column is coming from. Examples
 * include actual accounting data, budget and forecast.
 */
export default class AbstractPeriodColumnSource extends Model {
	isBudgetSource() {
		return false;
	}

	isForecastSource() {
		return false;
	}

	isForecastEstimateSource() {
		return false;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.isBudgetColumn = this.isBudgetSource();
		properties.isForecastEstimateColumn = this.isForecastEstimateSource();

		return properties;
	}
}
